import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { layoutWithCondition } from '@atlassian/jira-route-layout/src/utils/layout-with-condition/index.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { peopleProfilesRoute } from '@atlassian/jira-router-routes-people-profiles-routes/src/peopleProfilesRoute.tsx';
import { rightSidebarsLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { peopleProfilesEntrypoint } from '@atlassian/jira-spa-apps-people-profiles/entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const peopleProfilesPageEntrypoint = createPageEntryPoint({
	main: peopleProfilesEntrypoint,
	topNavigationMenuId: MENU_ID.PEOPLE,
	redirect: userSegRedirectEntrypoint,
});

export const peopleProfilesRouteEntry: Route = createEntry(peopleProfilesRoute, () => ({
	group: 'people-profiles',

	layout: layoutWithCondition(
		() => expValEquals('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'),
		rightSidebarsLayout,
		globalLayout,
	),

	navigation: {
		menuId: MENU_ID.PEOPLE,
	},

	resources: [...getNavigationResources(), getConsolidationStateResource()],
	ufoName: 'people-profiles',
	entryPoint: () => peopleProfilesPageEntrypoint,
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-people-profiles-entries/src/peopleProfilesRouteEntry.tsx',
			whichExportToUse: 'peopleProfilesRouteEntry',
		},

		enabled: true,
	},
}));
